<template>
  <div class="mobile-formitemselect-wrap">
    <div class="form-block-item" :class="{ error: error , vertical}">
      <label @click="showOptions = !showOptions"><em class="required">*</em>{{label}}</label>
      <div class="value-wrap" @click="showOptions = !showOptions" :style="{ marginTop: vertical && value && displayLabel ? '12px' : '0px' }">
        <span v-if="value && displayLabel">{{ displayLabel }}</span>
        <Icon :name="showOptions ? 'pullup' : 'pulldown'" size="24" />
      </div>
      
      <span class="errortip">{{LOCAL('error_required_cannot_empty')}}</span>

      <div class="form-block-select-options" v-if="showOptions" :style="{ height: `${options.length * 28 + (options.length - 1) * 12 + 1 + 12}px`, ...optionWrapStyle }">
        <div class="item" :class="{ active: value == oitem.value }" v-for="(oitem, oindex) in options" @click="selectHandle(oitem,oindex,options.length)" :key="oindex"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{oitem.label}}</span></div>
      </div>
    </div>

    <div class="mobile-formitemselect-wrap-bg" @click="showOptions = !showOptions" v-if="showOptions"></div>
  </div>
</template>

<script setup>
  import { ref, onMounted, watch } from 'vue';
  import * as Utils from '@/assets/utils';
  import Icon from '@/components/icon/index.vue';
  import Footer from '@/components/footer/index.vue';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';

  const emit = defineEmits([ 'change' ]);

  const props = defineProps({
    label: {
      type: String,
      defaultValue: ''
    },
    options: {
      type: Array,
      defaultValue: () => []
    },
    value: {
      type: Number,
      defaultValue: null
    },
    error: {
      type: Boolean,
      defaultValue: false
    },
    vertical: {
      type: Boolean,
      defaultValue: false
    },
    optionWrapStyle: {
      type: Object,
      defaultValue: {}
    },
  })

  const displayLabel = ref('');
  const initDisplayLabel = () => {
    if(props.options?.length > 0) {
      props.options.map(o => {
        if(o.value == props.value) {
          displayLabel.value = o.label
        }
      })
    }
  }
  watch(() => props.value, () => {
    initDisplayLabel()
  })
  onMounted(() => {
    initDisplayLabel()
  })

  const showOptions = ref(false);

  const selectHandle = (item,index,length) => {
    console.log('item', item,index,length)
    emit('change', [item,index,length]);
    showOptions.value = false;
  }
</script>

<style scoped lang="less">
  @import "index.less";
</style>
